import React from 'react';

function FlagCards() {
  return (
    <div
      style={{
        flexDirection: 'row',
        marginBottom: 10,
        textAlign: 'center',
      }}
    >
      <img
        src={require('../../../images/visa.png')}
        alt="visa"
        style={{ width: 30, height: 30, marginRight: 5 }}
      />
      <img
        src={require('../../../images/mastercard.png')}
        alt="master"
        style={{ width: 30, height: 30, marginRight: 5 }}
      />
      <img
        src={require('../../../images/amex.png')}
        alt="amex"
        style={{ width: 30, height: 30, marginRight: 5 }}
      />
      <img
        src={require('../../../images/elo.png')}
        alt="elo"
        style={{
          height: 21,
          width: 40,
          marginTop: 5,
          resizeMode: 'stretch',
          marginRight: 5,
        }}
      />
      <img
        alt="Logo cartão diners"
        src={require('../../../images/diners.png')}
        style={{ width: 30, height: 30 }}
      />
    </div>
  );
}

export default FlagCards;
